import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import * as serviceWorker from './serviceWorker';
import DomainHead from './components/domainHead/domainHead';
import DomainFooter from './components/domainFooter/domainFooter';

Sentry.init({
  dsn:
    'https://0c6c76552b61464182d8e84c2f4966c6@o1191978.ingest.sentry.io/6442612',
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  enabled: process.env.NODE_ENV !== 'development',
});

//ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.render(
  React.createElement(
    React.Fragment,
    null,
    React.createElement(DomainHead, null),
    React.createElement(App, null),
    React.createElement(DomainFooter, null)
  ),
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
